export default __webpack_public_path__ + "static/media/umicard_logo2.55fd4afe.png";